import React from 'react';

export type ProductStatusState = 'not-found' | 'error' | 'no-token';

interface ProductStatusScreenProps {
  state: string;
}

const wrapperStyle: React.CSSProperties = {
  flex: 1,
  minHeight: 0,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '2rem',
  boxSizing: 'border-box',
};

const titleStyle: React.CSSProperties = {
  margin: '0 0 0.5rem',
  fontSize: '1.25rem',
  fontWeight: 700,
  color: '#344050',
};

const textStyle: React.CSSProperties = {
  margin: 0,
  fontSize: '0.9rem',
  color: '#748194',
  lineHeight: 1.6,
};

const iconStyle: React.CSSProperties = {
  fontSize: '3.5rem',
  marginBottom: '1rem',
  lineHeight: 1,
};

const CONTENT: Record<
  ProductStatusState,
  { icon: string; title: string; message: string }
> = {
  'not-found': {
    icon: '📦',
    title: 'Prodotto non disponibile',
    message:
      'Il prodotto che stai cercando non è disponibile o è stato disattivato.',
  },
  error: {
    icon: '⚠️',
    title: 'Si è verificato un errore',
    message: 'Non è stato possibile caricare il prodotto. Riprova più tardi.',
  },
  'no-token': {
    icon: '🔒',
    title: 'Token non valido',
    message: 'Il token fornito non è valido.',
  },
};

export default function ProductStatusScreen({
  state,
}: ProductStatusScreenProps) {
  const content = CONTENT[state as ProductStatusState] ?? CONTENT['not-found'];

  return (
    <div style={wrapperStyle}>
      <div style={{ textAlign: 'center', maxWidth: 360 }}>
        <div style={iconStyle}>{content.icon}</div>
        <h2 style={titleStyle}>{content.title}</h2>
        <p style={textStyle}>{content.message}</p>
      </div>
    </div>
  );
}
